{
  "SET_NEW_PASSWORD": {
    "TITLE": "設定新密碼",
    "PASSWORD": {
      "LABEL": "密碼",
      "PLACEHOLDER": "密碼",
      "ERROR": "密碼過短。"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "確認密碼",
      "PLACEHOLDER": "確認密碼",
      "ERROR": "密碼不一致。"
    },
    "API": {
      "SUCCESS_MESSAGE": "密碼已成功變更。",
      "ERROR_MESSAGE": "無法連線至 Woot 伺服器，請稍後再試。"
    },
    "CAPTCHA": {
      "ERROR": "驗證已過期，請重新完成驗證。"
    },
    "SUBMIT": "送出"
  }
}
